module.exports = __webpack_public_path__ + "media/flags/us-e0150e99.svg";